export const SITE_COLUMNS = [
  {
    title: "Site ID",
    sortArrow: true,
    sortBy: "number",
    address: ["id"],
  },
  {
    title: "Site Name",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["name"],
  },
  {
    title: "Machine ID",
    sortArrow: true,
    sortBy: "number",
    address: ["machineID"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccFieldTechnician", "jbccSupervisor", "fullName"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccFieldTechnician", "fullName"],
  },
  {
    title: "FT Phone",
  },
  {
    title: "Subdivision",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["je", "subDivision", "name"],
  },
  {
    title: "Automation",
  },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Details" },
  { title: "Action" },
];

export const UNVISITED_SITE_COLUMNS = [
  { title: "SN" },
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["name"],
  },
  {
    title: "Last Visit Date",
    sortArrow: true,
    sortBy: "date",
    address: ["lastVisit"],
  },
  {
    title: "Days Since Last Visit",
    sortArrow: true,
    sortBy: "number",
    address: ["daysSinceLastVisit"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccTechnicianId"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["jbccSupervisorId"],
  },
];

export const STATION_REPAIRS_COLUMNS = [
  {
    title: "SN",
  },
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Machine ID",
    sortArrow: true,
    sortBy: "number",
    address: ["station", "machineID"],
  },
  {
    title: "Repair Date",
    sortArrow: true,
    sortBy: "date",
    address: ["repairDate"],
  },
  {
    title: "Work Done",
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "jbccFieldTechnician", "jbccSupervisor", "fullName"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "jbccFieldTechnician", "fullName"],
  },
  {
    title: "Subdivision",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "je", "subDivision", "name"],
  },
];

export const DEACTIVATED_SITES_HEADERS = [
  { label: "Site ID", className: "rounded-l-full" },
  { label: "Site Name" },
  { label: "Machine ID" },
  { label: "Subdivision" },
  { label: "Automation", className: "rounded-r-full" },
];

export const MATERIALTRANSPORTS_COLUMNS = [
  { title: "SN" },
  {
    title: "Material",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["material", "fullName"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "fullName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "fullName"],
  },
  { title: "Vehicle" },
  { title: "Driver" },
  {
    title: "Transport Date",
    sortArrow: true,
    sortBy: "date",
    address: ["dateOfTransport"],
  },
  {
    title: "Required Quantity",
    lineBreakTitle: ["Required", "Quantity"],
    sortArrow: true,
    sortBy: "number",
    address: ["quantityRequired"],
  },
  {
    title: "Qty Dispatched from Factory",
    lineBreakTitle: ["Qty Dispatched", "from Factory (A)"],
    sortArrow: true,
    sortBy: "number",
    address: ["quantityDispatchedFromFactory"],
  },
  {
    title: "Qty Received at Site",
    lineBreakTitle: ["Qty Received", "at site (B)"],
    sortArrow: true,
    sortBy: "number",
    address: ["quantityReceivedAtSite"],
  },
  {
    title: "Qty Dispatched from Site",
    lineBreakTitle: ["Qty Dispatched", "from site (C)"],
    sortArrow: true,
    sortBy: "number",
    address: ["quantityDispatchedFromSite"],
  },
  {
    title: "Qty Received at Factory",
    lineBreakTitle: ["Qty Received", "at Factory (D)"],
    sortArrow: true,
    sortBy: "number",
    address: ["quantityReceivedAtFactory"],
  },
  {
    title: "Excess At Factory",
    lineBreakTitle: ["Excess Qty", "at Factory (D-A)"],
    sortArrow: true,
    sortBy: "number",
    address: ["excessAtFactory"],
  },
  {
    title: "Excess at site",
    lineBreakTitle: ["Excess Qty", "at site (B-C)"],
    sortArrow: true,
    sortBy: "number",
    address: ["excessAtSite"],
  },
  { title: "Status", sortArrow: true, sortBy: "number", address: ["status"] },
  { title: "Action" },
];
